module.exports = __webpack_public_path__ + "img/dongjie.5ffeab67.png";